<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="heading-1 mb-4">
                            <span>{{ titulo }}</span>
                            <div class="float-right">
                                <span class="text-primary">
                                    <i
                                        class="fa fa-refresh fa-lg icon-button"
                                        title="Atualizar"
                                        @click.stop="
                                            $emit('atualizar-listagem')
                                        "
                                    ></i>
                                </span>
                            </div>
                        </h4>
                        <app-tabela
                            :itens="consultorias"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <!-- <template slot="status" slot-scope="data">
                                <app-status
                                    :status="data.statusDescr"
                                ></app-status>
                            </template> -->
                            <template slot="valor" slot-scope="data">{{
                                data.produtoValor | currency
                            }}</template>
                            <template slot="acoes" slot-scope="data">
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// import StatusFin from './../StatusFinIdRm'

export default {
    components: {
        // StatusFin
    },

    props: {
        consultorias: {
            type: Array,
            default: () => []
        },

        titulo: {
            type: String,
            default: () => 'APP SEBRAE - CONSULTORIAS'
        },

        solicitacoes: {
            type: Boolean,
            default: () => false
        },

        fornecedor: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            camposConsultorias: [
                {
                    key: 'idSolicitacao',
                    label: 'Id',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'credenciada',
                    label: 'Credenciada',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'clientePJ',
                    label: 'Cliente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'produtoDescricao',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataSolicitacao',
                    label: 'Solicitada em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAceitacao',
                    label: 'Aceita em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAceitacaoCondicoesContratuais',
                    label: 'Condições contratuais aceita em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataContratacao',
                    label: 'Contratada em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                // {
                //     key: 'valor',
                //     label: 'Valor',
                //     tdClass: 'text-nowrap text-right'
                // },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            camposSolicitacoes: [
                {
                    key: 'idSolicitacao',
                    label: 'Id',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'credenciada',
                    label: 'Credenciada',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'clientePJ',
                    label: 'Cliente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'produtoDescricao',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataSolicitacao',
                    label: 'Solicitada em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataLimiteAceitacao',
                    label: 'Limite aceite',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAceitacao',
                    label: 'Aceite / Não aceite em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                // {
                //     key: 'valor',
                //     label: 'Valor',
                //     tdClass: 'text-nowrap text-right'
                // },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {},

    computed: {
        campos() {
            if (this.solicitacoes) {
                if (this.fornecedor) {
                    let camposTemp = [...this.camposSolicitacoes]
                    camposTemp.splice(1, 1)
                    return [...camposTemp]
                }
                return [...this.camposSolicitacoes]
            } else {
                if (this.fornecedor) {
                    let camposTemp = [...this.camposConsultorias]
                    camposTemp.splice(1, 1)
                    return [...camposTemp]
                }
                return [...this.camposConsultorias]
            }
        }
    },

    mounted() {}
}
</script>
